import { Link } from '@heroui/link';
import Icon from '@/components/Common/Icons/Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslations } from 'next-intl';

const AuthenticatedMenu = ({ logout }: { logout: () => void }) => {
  const t = useTranslations('navbar');
  const navigateWithFullReload = React.useCallback((href: string) => {
    if (typeof window === 'undefined') {
      return;
    }

    window.location.assign(href);
  }, []);

  return (
    <div className="flex flex-col gap-5">
      <div>
        <Link
          href="/profile"
          onClick={(event) => {
            event.preventDefault();
            navigateWithFullReload('/profile');
          }}
          className="text-[15px] cursor-pointer text-gray-dark w-[312px] h-[40px] border border-gray-medium2 rounded-[5px] p-2 flex gap-1 font-normal"
        >
          <Icon name="Account" width={20} height={20} />
          {t('account')}
          <div className="absolute right-3">
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="text-[16px] mr-1"
            />
          </div>
        </Link>
      </div>

      <div>
        <Link
          href="/blog"
          onClick={(event) => {
            event.preventDefault();
            navigateWithFullReload('/blog');
          }}
          className="text-[15px] text-gray-dark w-[312px] h-[40px] border border-gray-medium2 rounded-[5px] p-2 flex gap-1 font-normal"
        >
          <Icon name="Blog" width={20} height={20} />
          {t('blog')}
          <div className="absolute right-3">
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="text-[16px] mr-1"
            />
          </div>
        </Link>
      </div>
      <div>
        <Link
          href="/faq"
          onClick={(event) => {
            event.preventDefault();
            navigateWithFullReload('/faq');
          }}
          className="text-[15px] text-gray-dark w-[312px] h-[40px] border border-gray-medium2 rounded-[5px] p-2 flex gap-1 font-normal"
        >
          <Icon name="Help" width={20} height={20} />
          {t('help')}
          <div className="absolute right-3">
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="text-[16px] mr-1"
            />
          </div>
        </Link>
      </div>
      <div>
        <Link
          onClick={() => logout()}
          className="text-[15px] text-gray-dark w-[312px] h-[40px] border border-gray-medium2 rounded-[5px] p-2 flex gap-1 font-normal"
        >
          <Icon name="Logout" width={20} height={20} />
          <span>{t('logout')}</span>
          <div className="absolute right-3">
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="text-[16px] mr-1"
            />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default AuthenticatedMenu;
